export const theme_black_color = "#ff702e";
export const theme_white_color = "#008800";
export const theme_white_color_bg = "#00880014";
export const theme_black_color_bg = "#ff702f14";
export const theme_white_bg_color = "#eff6ed";
export const theme_black_bg_color = "#fff4ef";
export const white = '#ffffff';
export const black = "#000000";

